/**
 * Allys Navigation Skeleton
 *
 * Matches the CoreNavigation pill-shaped glass nav bar.
 * Included at the top of every page skeleton so the navigation
 * area remains visible during page transitions.
 */

export function AllysNavSkeleton() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 py-3 md:py-4 px-3 sm:px-4 md:px-6 lg:px-8">
      <div className="flex items-center h-16 md:h-14 lg:h-16 px-4 sm:px-5 md:px-4 lg:px-6 shadow-xl bg-linear-to-r from-white/20 via-white/30 to-white/20 backdrop-blur-xl border border-white/30 rounded-full overflow-hidden gap-3 md:gap-3 lg:gap-4 xl:gap-6">
        {/* Logo placeholder */}
        <div className="shrink-0 h-8 w-24 rounded bg-white/20 skeleton-shimmer" />

        {/* Desktop nav links — hidden on mobile */}
        <div className="hidden lg:flex flex-1 items-center justify-center gap-6">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="h-4 w-16 rounded bg-white/15 skeleton-shimmer" />
          ))}
        </div>

        {/* Right side actions */}
        <div className="flex items-center gap-2 ml-auto">
          <div className="hidden md:block h-8 w-16 rounded-full bg-white/15 skeleton-shimmer" />
          <div className="hidden md:block h-8 w-16 rounded-full bg-white/15 skeleton-shimmer" />
          {/* Mobile hamburger */}
          <div className="lg:hidden h-8 w-8 rounded bg-white/15 skeleton-shimmer" />
        </div>
      </div>
    </nav>
  );
}
